import { Link } from "react-router-dom";
import { fa_currency, fa_number } from "../../utils/PersianNum";


function RelatedProduct({prod}) {
  return (
    <Link
      to={`/product/${prod.id}/${prod.name.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').toLowerCase()}`}
      className="col text-decoration-none"
    >
      <div className="card shadow-sm">
        {prod.sale_price && prod.sale_price > 0 && prod.price > 0 &&
            <div
              className="badge py-2 text-white position-absolute"
              style={{ top: "0.5rem", right: "0.5rem" }}
            >
              {fa_number(Math.round(((prod.price - prod.sale_price)/prod.price)*100))}٪ تخفیف
          </div>}
        <img
          className="card-img-top bg-dark cover"
          height="200"
          alt=""
          src={prod.images}
        />
        <div className="card-body">
          <h5 className="card-title text-center text-dark text-truncate">
          {prod.name}
          </h5>
          <p className="card-text text-center text-muted">
            {prod.sale_price && prod.sale_price > 0 ?
            <>
              <del>{fa_currency(+prod.price)}</del> {fa_currency(+prod.sale_price)}تومان
            </> :
              `${fa_currency(+prod.price)}تومان`
            }
          </p>
        </div>
      </div>
    </Link>
  );
}

export default RelatedProduct;
